import { render, staticRenderFns } from "./AlertText.vue?vue&type=template&id=30dee812&scoped=true&"
import script from "./AlertText.vue?vue&type=script&lang=js&"
export * from "./AlertText.vue?vue&type=script&lang=js&"
import style0 from "./AlertText.vue?vue&type=style&index=0&id=30dee812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dee812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
